export const PET_LOSS_READINESS_PATH = '/pet-loss-readiness';

export const PET_LOSS_PARTNER_PORTAL_PATH = '/pet-loss-partners';

export const PET_LOSS_PARTNER_SIGN_IN_PATH = '/pet-loss-partners/sign-in';

const SIGN_IN_TOKEN_KEY = 'token';

export function buildPetLossPartnerPagePath(slug: string): string {
  return `${PET_LOSS_READINESS_PATH}/${encodeURIComponent(slug)}`;
}

export function buildPetLossPartnerSignInPath(token: string): string {
  return `${PET_LOSS_PARTNER_SIGN_IN_PATH}#${SIGN_IN_TOKEN_KEY}=${encodeURIComponent(token)}`;
}

export function readPetLossPartnerSignInToken(
  hash: string | null | undefined
): string | null {
  if (!hash) return null;
  const fragment = hash.startsWith('#') ? hash.slice(1) : hash;
  const token = new URLSearchParams(fragment).get(SIGN_IN_TOKEN_KEY)?.trim();
  return token ? token : null;
}

export const PET_LOSS_PARTNER_SESSION_HEADER = 'x-pet-loss-partner-session';
